<nb-card>
  <nb-card-header class="header">
    <div class="header-left-icons"></div>
    <div class="title" [class.red-title]="isMaintenanceContract">
      {{ (isMaintenanceContract ? 'documents.sheet.maintenance_title' : 'documents.sheet.title') | translate }}
    </div>
    <span class="close-btn" (click)="$event.stopPropagation(); close()">
      <i class="fa-light fa-xmark"></i>
    </span>
  </nb-card-header>

  <nb-card-body class="body">
    <form [formGroup]="form" class="form-section" [class.maintenance-form]="isMaintenanceContract" [hidden]="loading">

      @if (isEditing) {
        <div class="form-field">
          <label>{{ 'documents.sheet.label' | translate }}</label>
          <input nbInput type="text" formControlName="label" fullWidth placeholder="-">
        </div>

        <div class="form-field">
          <label>{{ 'documents.sheet.type' | translate }}</label>
          <span class="field-value">{{ editDoc?.type || '-' }}</span>
        </div>

        <div class="form-field">
          <label>{{ 'documents.sheet.url' | translate }}</label>
          <input nbInput type="text" formControlName="url" fullWidth placeholder="-">
        </div>

        @if (isMaintenanceContract) {
          <div class="form-field autocomplete-container">
            <label>{{ 'documents.sheet.company' | translate }}</label>
            <input nbInput type="text" formControlName="company" fullWidth placeholder="-"
              (input)="onCompanyInputChange($any($event.target).value)"
              (focus)="onCompanyInputFocus($any($event.target).value)"
              (blur)="onCompanyBlur()" />
            @if (filteredCorporates.length > 0) {
              <div class="autocomplete-dropdown">
                @for (name of filteredCorporates; track name) {
                  <div class="autocomplete-item" (mousedown)="selectCorporate(name)">{{ name }}</div>
                }
              </div>
            }
          </div>

          <div class="form-field">
            <label>{{ 'documents.sheet.expiry_date' | translate }}</label>
            <div class="datepicker-field">
              <input nbInput class="date-input" [nbDatepicker]="expiryDatePicker1" formControlName="expiry_date" placeholder="-" (click)="!expiryDatePicker1.isShown && expiryDatePicker1.show()">
              <button
                type="button"
                class="datepicker-toggle"
                (click)="$event.preventDefault(); $event.stopPropagation(); expiryDatePicker1.isShown ? expiryDatePicker1.hide() : expiryDatePicker1.show()"
              >
                <i class="fa-light fa-calendar"></i>
              </button>
            </div>
            <nb-datepicker #expiryDatePicker1></nb-datepicker>
          </div>

          <div class="form-field clickable-field" (click)="openEquipmentSelection()">
            <label class="equipment-label">{{ 'documents.sheet.linked_equipments' | translate }}</label>
            <div class="equipment-input-container">
              <input nbInput type="text" [value]="linkedEquipmentIds.length > 0 ? linkedEquipmentIds.length : ''" placeholder="-" readonly fullWidth style="cursor: pointer;">
              <span class="right-chevron">
                <i class="fa-light fa-chevron-right"></i>
              </span>
            </div>
          </div>
        }
      } @else {
        <div [hidden]="step !== 1">
          <div class="form-field">
            <label>{{ 'documents.sheet.label' | translate }}</label>
            <input nbInput type="text" formControlName="label" fullWidth placeholder="-">
          </div>

          <div class="form-field">
            <label>{{ 'documents.sheet.type' | translate }}</label>
            <nb-select formControlName="docType" fullWidth placeholder="-">
              @if (loadingDocTypes) {
                <nb-option [value]="null" disabled>{{ 'Loading...' | translate }}</nb-option>
              }
              @for (docType of documentTypes; track docType.id) {
                <nb-option [value]="docType.id">{{ docType.label }}</nb-option>
              }
            </nb-select>
          </div>

          <div class="form-field">
            <label>{{ 'documents.sheet.linked_to' | translate }}</label>
            @if (isPerimeterMode) {
              <span class="field-value">{{ perimeterLabel || '-' }}</span>
            } @else if (isAssetMode || isActionMode) {
              <span class="field-value">{{ linkedToLabel || '-' }}</span>
            } @else {
              <nb-select formControlName="investId" fullWidth placeholder="-">
                @for (invest of investments; track invest.id) {
                  <nb-option [value]="invest.id">{{ invest.label }}</nb-option>
                }
              </nb-select>
            }
          </div>

          <div class="form-field">
            <label>{{ 'documents.sheet.url' | translate }}</label>
            <input nbInput type="text" formControlName="url" fullWidth placeholder="-">
          </div>
        </div>

        <div [hidden]="step !== 2">
          <div class="form-field autocomplete-container">
            <label>{{ 'documents.sheet.company' | translate }}</label>
            <input nbInput type="text" formControlName="company" fullWidth placeholder="-"
              (input)="onCompanyInputChange($any($event.target).value)"
              (focus)="onCompanyInputFocus($any($event.target).value)"
              (blur)="onCompanyBlur()" />
            @if (filteredCorporates.length > 0) {
              <div class="autocomplete-dropdown">
                @for (name of filteredCorporates; track name) {
                  <div class="autocomplete-item" (mousedown)="selectCorporate(name)">{{ name }}</div>
                }
              </div>
            }
          </div>

          <div class="form-field">
            <label>{{ 'documents.sheet.expiry_date' | translate }}</label>
            <div class="datepicker-field">
              <input nbInput class="date-input" [nbDatepicker]="expiryDatePicker" formControlName="expiry_date" placeholder="-" (click)="!expiryDatePicker.isShown && expiryDatePicker.show()">
              <button
                type="button"
                class="datepicker-toggle"
                (click)="$event.preventDefault(); $event.stopPropagation(); expiryDatePicker.isShown ? expiryDatePicker.hide() : expiryDatePicker.show()"
              >
                <i class="fa-light fa-calendar"></i>
              </button>
            </div>
            <nb-datepicker #expiryDatePicker></nb-datepicker>
          </div>

          <div class="form-field clickable-field" (click)="openEquipmentSelection()">
            <label class="equipment-label">{{ 'documents.sheet.linked_equipments' | translate }}</label>
            <div class="equipment-input-container">
              <input nbInput type="text" [value]="linkedEquipmentIds.length > 0 ? linkedEquipmentIds.length : ''" placeholder="-" readonly fullWidth style="cursor: pointer;">
              <span class="right-chevron">
                <i class="fa-light fa-chevron-right"></i>
              </span>
            </div>
          </div>
        </div>
      }

    </form>
  </nb-card-body>

  <nb-card-footer class="footer">
    <div class="submit-btn-container">
      @if (isEditing) {
        <button class="submit-btn" [disabled]="loading" (click)="$event.stopPropagation(); addDocument()">
          {{ "Save" | translate | uppercase }}
        </button>
      } @else if (step === 1) {
        <button class="submit-btn" [disabled]="loading || !isStep1Valid()" (click)="$event.stopPropagation(); nextOrSubmit()">
          {{ (isMaintenanceContract ? 'Next' : 'Save') | translate | uppercase }}
        </button>
      } @else {
        <button class="submit-btn" [disabled]="loading" (click)="$event.stopPropagation(); addDocument()">
          {{ "Add" | translate | uppercase }}
        </button>
      }
    </div>
  </nb-card-footer>
</nb-card>
